var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnsFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e5e5e5;}.b{fill:none;stroke:#4d4f5c;stroke-miterlimit:10;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3490 -8429)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3575 8191)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32,
    rx: 4,
    transform: "translate(85 238)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5360.894 8226.456)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M49.259,114.827v-2.4a.424.424,0,0,1,.424-.424H61.73a.424.424,0,0,1,.423.424V124.47a.424.424,0,0,1-.423.424H53.839",
    transform: "translate(1834.879 98.287)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 8.96,
    height: 3.636,
    transform: "translate(1877.032 216.328)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 8.96,
    height: 3.636,
    transform: "translate(1877.032 220.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 8.96,
    height: 3.636,
    transform: "translate(1877.032 223.955)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnsFilter);
export default __webpack_public_path__ + "static/media/columns-filter.9fdb55f0529bc87b0e94cd01b3b59788.svg";
export { ForwardRef as ReactComponent };